package com.essntl.features.organization.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [OrganizationSupabaseDataSource::class])
internal class OrganizationSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<OrganizationDto> {
    override val tableName: String = "organization"
}
